import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany } from '@apexdesigner/schema-tools';

export const processUserInterface = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    name: z
      .string()
      .nullable()
      .optional()
      .requiredFinal()
      .describe('Component identifier'),

    displayName: z
      .string()
      .nullable()
      .optional()
      .meta({ format: 'capitalCase' })
      .describe('Human-readable label'),

    description: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Description'),

    processUserInterfaceProperties: hasMany(
      'ProcessUserInterfaceProperty',
      'userInterfaceId',
    ),
  })
  .describe('A UI component available for user tasks.')
  .as('ProcessUserInterface');

export { processUserInterface as processUserInterfaceSchema };
